import { GridOptions } from 'ag-grid-community';

export interface ServerSideCacheConfig {
  paginationPageSize: number;
  cacheBlockSize: number;
  maxBlocksInCache: number;
}

export function getRequiredBlocks(paginationPageSize: number, cacheBlockSize: number): number {
  if (!paginationPageSize || !cacheBlockSize) {
    return 0;
  }
  return Math.ceil(paginationPageSize / cacheBlockSize);
}

export function getMaxCachedRows(cacheBlockSize: number, maxBlocksInCache: number): number {
  if (!cacheBlockSize || !maxBlocksInCache) {
    return 0;
  }
  return cacheBlockSize * maxBlocksInCache;
}

export function shouldValidateServerSideCache(gridOptions: GridOptions): boolean {
  return gridOptions &&
    gridOptions.rowModelType === 'serverSide' &&
    gridOptions.pagination === true;
}

export function isServerSideCacheConfigValid(config: ServerSideCacheConfig): boolean {
  const paginationPageSize = config.paginationPageSize;
  const cacheBlockSize = config.cacheBlockSize;
  const maxBlocksInCache = config.maxBlocksInCache;

  if (!paginationPageSize || !cacheBlockSize) {
    return true;
  }

  if (maxBlocksInCache === 0) {
    return true;
  }

  const effectiveMaxBlocks = maxBlocksInCache != null ? maxBlocksInCache : 3;
  return getRequiredBlocks(paginationPageSize, cacheBlockSize) <= effectiveMaxBlocks;
}

export function buildCacheConfigErrorMessage(config: ServerSideCacheConfig): string {
  const maxBlocks = config.maxBlocksInCache != null ? config.maxBlocksInCache : 3;
  const requiredBlocks = getRequiredBlocks(config.paginationPageSize, config.cacheBlockSize);
  const maxRows = getMaxCachedRows(config.cacheBlockSize, maxBlocks);
  return (
    'Server-side grid cache cannot hold ' + config.paginationPageSize + ' rows per page: needs ' +
    requiredBlocks + ' blocks of ' + config.cacheBlockSize + ' but maxBlocksInCache is ' + maxBlocks +
    ' (max ' + maxRows + ' rows). Reduce page size or increase cacheBlockSize / maxBlocksInCache.'
  );
}
